<template>
  <v-dialog
    :model-value="visible"
    persistent
    scrim="rgba(0, 0, 0, 0.6)"
    max-width="300"
    transition="dialog-transition"
  >
    <v-card
      class="pa-6 d-flex flex-column align-center justify-center text-center"
      elevation="8"
      rounded="xl"
      style="min-width: 200px"
    >
      <!-- Imagen SVG -->
      <img :src="svgPath" alt="loading svg" class="svg-img mb-4" />

      <!-- Con mensaje propio (ej. progreso) NO usamos el typewriter de ancho
           fijo (12ch), que recortaria el texto. -->
      <div v-if="message" class="loading-message">
        {{ messageText }}
      </div>
      <div v-else class="typing-text">
        {{ messageText }}
      </div>

      <!-- Barra de progreso (cuando se pasa un progress 0-100) -->
      <v-progress-linear
        v-if="progress != null"
        :model-value="progress"
        height="14"
        color="#c1121f"
        rounded
        class="mt-3"
        style="width: 100%"
      >
        <strong style="font-size: 11px; color: #fff">
          {{ Math.round(progress) }}%
        </strong>
      </v-progress-linear>
    </v-card>
  </v-dialog>
</template>

<script>
import LogoSvg from "@/assets/prometheus-light.png";
import "@/css/ModelIA/StylesLoading.css";
export default {
  name: "LoadingModel",
  data() {
    return {
      svgPath: LogoSvg,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },

    message: {
      type: String,
      default: null,
    },
    // Progreso 0-100 para mostrar barra. null = sin barra.
    progress: {
      type: Number,
      default: null,
    },
  },
  computed: {
    messageText() {
      return this.message || this.$t("loading");
    },
  },
};
</script>

<style scoped>
/* Mensaje propio (progreso/cola): texto normal, sin recorte del typewriter. */
.loading-message {
  font-weight: 600;
  text-align: center;
  font-family: monospace;
}
</style>

<!-- <script setup>
defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
</script> -->
